import Component from '../core/Component'
import Flickity from 'flickity-sync'
import { queryAll } from '../utils/dom'
import Scroll from '../services/Scroll'

const defaults = {
    sync: null,
    wrapAround: true,
    prevNextButtons: false,
    pageDots: false,
    resize: true,
    draggable: true,
    selectedAttraction: 0.025,
    friction: 0.28
}

export default class HomepageSlider extends Component {

    constructor(element) {
        super(element, defaults)

        this.isDragging = false
        this.flickity = null
        this.width = 0
        this.selectedIndex = 0

        this.ref = {
            images: []
        }

    }

    prepare() {
        this.flickity = new Flickity(this.element, this.options)
        this.flickity.on('dragStart', this.handleDragStart)
        this.flickity.on('settle', this.handleSettle)
        this.flickity.on('change', this.handleChange)
        this.flickity.on('scroll', this.handleScroll)
        this.element.addEventListener('click', this.handleClick)
        Scroll.on('resize', this.handleResize)
        this.preload(0)
        this.resize()
    }

    destroy() {
        Scroll.off('resize', this.handleResize)
        if (this.flickity) {
            this.flickity.destroy()
            this.flickity = null
        }
    }

    handleDragStart = () => {
        this.isDragging = true
        this.emit('dragStart')
    }

    handleSettle = () => {
        this.isDragging = false
        this.selectedIndex = this.flickity.selectedIndex
        this.emit('dragEnd')
    }

    handleResize = () => {
        this.resize()
    }

    handleScroll = (event, progress) => {
        progress += this.width
        const count = this.ref.images.length
        const current = Math.floor(progress / this.width) || count
        const ratio = (progress % this.width)/this.width
        const diff = this.width * 0.66 * ratio
        let prev = current - 1

        if (prev < 0) {
            prev = count
        }

        this.flickity.slides.forEach((slide, index) => {
            this.ref.images[index].style.transform = `translateX(${index === prev ? diff : 0}px)`
        })
    }

    handleClick = event => {
        event.preventDefault()

        if (!this.isDragging) {
            this.flickity.next()
        }
    }

    handleChange = index => {
        this.preload(index)

        this.emit('change', {
            index: index
        })
    }

    resize() {
        this.width = this.element.offsetWidth
    }

    preload(index) {
        const { slides } = this.flickity
        const nextIndex = (index + 1) % slides.length
        const previousIndex = index > 0 ? index - 1 : slides.length - 1

        const targets = [slides[nextIndex], slides[index], slides[previousIndex]]
            .map(slide => slide.cells[0].element)
            .flatMap(element => queryAll('[data-srcset], [data-src]', element))
            .forEach(target => {
                if (target.dataset.sizes) {
                    target.setAttribute('sizes', target.dataset.sizes)
                    target.removeAttribute('data-size')
                }

                if (target.dataset.srcset) {
                    target.setAttribute('srcset', target.dataset.srcset)
                    target.removeAttribute('data-srcset')
                }

                if (target.dataset.src) {
                    target.setAttribute('src', target.dataset.src)
                    target.removeAttribute('data-src')
                }
            })
    }

    select(index) {
        this.flickity?.select(index)
    }

    next() {
        this.flickity?.next()
    }
}
